// GENERATED from the v0.9 archive (HenHouse_v0.9.zip) by a one-off port script, then
// maintained by hand. 120 names, drawn without replacement per save.
export const ROOSTER_NAMES: readonly string[] = [
  "Buck", "Rex", "Chief", "Duke", "Dash", "Clint", "Marshal", "King", "Doc", "Ace", "Atlas", "Augustus", "Banjo",
  "Baron", "Bear", "Beau", "Biggs", "Boomer", "Boone", "Boss", "Bowie", "Brody", "Bruno", "Brutus", "Bubba",
  "Buster", "Captain", "Cash", "Champ", "Cletus", "Cody", "Cole", "Colonel", "Cooper", "Coyote", "Cyrus",
  "Dakota", "Diesel", "Drake", "Earl", "Ezra", "Falcon", "Flint", "Floyd", "Garth", "Grit", "Gunner", "Gus",
  "Hank", "Hawk", "Hoss", "Hoyt", "Hudson", "Hugo", "Jagger", "Jasper", "Jeb", "Jed", "Jesse", "Judge", "Junior",
  "Kid", "Lucky", "Mack", "Magnus", "Major", "Marvin", "Maverick", "Maximus", "Mayor", "Murphy", "Norman",
  "Odin", "Otis", "Otto", "Pecker", "Phineas", "Ranger", "Raven", "Reggie", "Rocco", "Rocky", "Roscoe", "Roy",
  "Russell", "Sarge", "Sawyer", "Scooter", "Sheriff", "Silas", "Skip", "Slade", "Slim", "Smokey", "Spike",
  "Squire", "Steel", "Sterling", "Stone", "Talon", "Tank", "Tex", "Thaddeus", "Thor", "Titan", "Travis",
  "Tucker", "Vernon", "Wade", "Walt", "Wesley", "Whiskey", "Wilbur", "Wolf", "Wyatt", "Zeke", "Zeus", "Ridge",
  "Bruiser", "Riggs",
];
